import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { billingScopes } from '../../../billing-consts';
import { UploadFile } from '../../../classes/upload-obj.class';
import { BadgeComponent } from '../../../components/badge/badge.component';
import { GROWTHBOOK } from '../../../growthbook';
import { PICFLOW_CHECKOUT } from '../../../picflow-checkout';
import { AiService } from '../../../services/ai.service';
import { BoxService } from '../../../services/box.service';
import { DropboxService } from '../../../services/dropbox.service';
import { GoogleDriveService } from '../../../services/google-drive.service';
import { PermissionService } from '../../../services/permission.service';
import { UpgradeBadgeComponent } from '../../../shared-extra/components/pro-tag/upgrade-badge.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-upload-source-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent, UpgradeBadgeComponent, BadgeComponent],
  templateUrl: './upload-source-menu.component.html',
  styleUrl: './upload-source-menu.component.scss',
})
export class UploadSourceMenuComponent {
  private googleDriveService = inject(GoogleDriveService);
  private dropboxService = inject(DropboxService);
  private boxService = inject(BoxService);
  private permissionService = inject(PermissionService);
  private checkoutService = inject(PICFLOW_CHECKOUT);
  private aiService = inject(AiService);
  public growthBook = inject(GROWTHBOOK);

  @Input() uploadIdPrefix: string;
  @Input({ required: true }) sectionId: string;
  @Output() onClose = new EventEmitter<void>();
  @Output() onUpload = new EventEmitter<UploadFile[]>();

  async openDropboxDialog() {
    if (!this.permissionService.canDisplayElement(billingScopes.gallery.otherSourceUpload)) {
      return this.checkoutService.open(billingScopes.gallery.otherSourceUpload);
    }
    const files = await this.dropboxService.startChooser();
    if (!files.length) return;
    this.onUpload.emit(files);
  }

  async openGoogleDriveDialog() {
    if (!this.permissionService.canDisplayElement(billingScopes.gallery.otherSourceUpload)) {
      return this.checkoutService.open(billingScopes.gallery.otherSourceUpload);
    }
    const files = await this.googleDriveService.startChooser();
    this.onUpload.emit(files);
  }

  async openBoxDialog() {
    if (!this.permissionService.canDisplayElement(billingScopes.gallery.otherSourceUpload)) {
      return this.checkoutService.open(billingScopes.gallery.otherSourceUpload);
    }
    const files = await this.boxService.startChooser();
    this.onUpload.emit(files);
  }

  async openAiDialog() {
    this.aiService.openAiUi(this.sectionId);
  }
}
